/**
 * ICpochipochi feature の公開ルート定義
 *
 * `lib/middleware/route-registry.ts` から static import される。
 *
 * Edge Runtime 制約:
 * - 純定数 export のみ（関数呼び出し・副作用なし）
 *
 * @see docs/計画/2026-05-09-ICpochipochi-漏れ抽象化.md L-A3
 */

export const ICPOCHIPOCHI_PUBLIC_PATHS = {
  pages: [
    '/ICpochipochi/portal',
    '/ICpochipochi/catalog',
    // お客様アクセスコード入室ページ（app/customer → app/projects/customer ブリッジ）。
    // 招待メール記載の loginUrl (`/customer?project=<id>`) の着地先で、未登録だと
    // middleware が /login (スタッフ用) へ 307 し顧客が入室できない（2026-07-06 本番実測で検出）。
    // ページは匿名前提のコード入力フォームのみで認証前のデータ露出なし。
    '/customer',
  ] as const,
  apis: ['/api/ICpochipochi/customer'] as const,
} as const
